import { MsalAuthenticationResult } from '@azure/msal-react';
import * as React from 'react';

export const ErrorComponent: React.ElementType<MsalAuthenticationResult> = ({
  error,
}) => {
  return <p>An Error Occurred: {error?.errorMessage}</p>;
};
